<div class="container-fluid" style="overflow: auto;">

  <div>

    <div class="mx-auto" style="max-width: 950px; margin-top: 40px;">
      <h2>Confirm Information & Set Password</h2>

      <div class="bg-light p-5 rounded-lg m-3 rounded-2">

        @if(hasUser) {
        <h3 style="margin-bottom: 20px;">Email or reset token incorrect</h3>
        <h4 style="margin-bottom: 20px;">Please check the link and try again</h4>
        <a class="btn btn-default" routerLink="/home" routerLinkActive="active" style="margin-left: 95px;">Go to
          Home</a>
        }
        @else {

        <form [formGroup]="form" (ngSubmit)="onSubmit()" class="k-form-inline">

          <div class="k-form-field">
            <label for="first_name" class="form-label col-3">First name</label>
            <div class="col-8">
              <input type="text" class="form-control" formControlName="first_name" id="first_name">
            </div>
          </div>

          <div class="k-form-field">
            <label for="last_name" class="form-label col-3">Last name</label>
            <div class="col-8">
              <input type="text" class="form-control" formControlName="last_name" id="last_name">
              <div *ngIf="form.hasError('firstOrLastNameRequired')" class="alert alert-danger">
                <div>First name or last name is required.</div>
              </div>
            </div>
          </div>

          <div class="k-form-field">
            <div class="col-md-8 offset-md-3">
              <input type="checkbox" kendoCheckBox formControlName="newsletter" style="margin-right: 5px" />
              <label class="k-checkbox-label" style="margin-top: -5px;">Send me news about REFLEXIS</label>
            </div>
          </div>
          <div class="k-form-field">
            <div class="col-md-8 offset-md-3">
              <input type="checkbox" kendoCheckBox formControlName="research_consent" style="margin-right: 5px" />
              <label class="k-checkbox-label" style="margin-top: -5px;">I consent that my de-identified data can be used
                for research purposes</label>
            </div>
          </div>

          <div class="k-form-field">
            <label for="password" class="form-label col col-md-3 k-label">New Password</label>
            <div class="col col-md-8">
              <input type="password" id="password" formControlName="password" class="form-control">
              <div *ngIf="f['password'].touched && f['password'].invalid" class="alert alert-danger">
                <div *ngIf="f['password'].errors && f['password'].errors['required']">Password is required.</div>
                <div *ngIf="password?.errors?.['minlength']">
                  Name must be at least 6 characters long.
                </div>
              </div>
            </div>
          </div>

          <div class="k-form-field">
            <label class="form-label col col-md-3 k-label" for="confirmedPassword">Confirm Password</label>
            <div class="col col-md-8">
              <input type="password" formControlName="confirmedPassword" class="form-control" name="confirmedPassword"
                id="confirmedPassword" autocomplete="new-password">
              <div *ngIf="confirmedPassword?.invalid && (confirmedPassword?.dirty || confirmedPassword?.touched)"
                class="alert alert-danger">
                <div *ngIf="confirmedPassword?.errors?.['required']">Confirm password is required.</div>
              </div>
              <div *ngIf="form.errors?.['confirmedPasswordValidator'] && (form.touched || form.dirty)"
                class="alert alert-danger">
                Passwords must match.</div>
            </div>
          </div>

          <div class="d-grid d-md-flex justify-content-md-end">
            <button type="button" class="btn btn-primary me-md-2" type="submit" [disabled]="form.invalid">
              Save</button>
            <button type="button" class="btn btn-secondary" (click)="cancelPassword()"> Cancel</button>
          </div>

        </form>
        }
      </div>

    </div>
  </div>

</div>

<kendo-dialog *ngIf="updateSuccess" (close)="reloadUser()" [minWidth]="250" [width]="450">

  <h4>Password Successfully Updated!</h4>

  <kendo-dialog-actions>
    <button kendoButton (click)="reloadUser()" themeColor="success">Continue</button>
  </kendo-dialog-actions>
</kendo-dialog>
